import logo from 'assets/integrations/linear/icon.svg'

import IntegrationsModal from '../../shared/Modal'
import LinearInstallDescription from './LinearInstallDescription'
import LinearSettingsForm from './LinearSettingsForm'

export default function IntegrationsLinearModal(props) {
  return (
    <IntegrationsModal
      {...props}
      InstallDescription={LinearInstallDescription}
      logo={logo}
      provider="LINEAR"
      providerStylized="Linear"
      tagLine="Create and link Linear issues directly from Groove conversations."
      screenShots={{ 'Linear logo': logo }}
      SettingsForm={LinearSettingsForm}
    />
  )
}
